
/*
*  Internacionalização
*  Adicionar o objeto no settings importando LANGUAGES e DEFAULT_LANGUAGE do index
*  i18n: {
*    DEFAULT_LANGUAGE,
*    LANGUAGES
*  }
*  Criado pipe translate para facilitar o uso
*  ex: <p>{{ 'header.registerButtonText' | translate}}</p>
*
*/

export const BR = {
  header: {
    registerButtonText: 'CADASTRE-SE',
  },
  auth: {
    loginForm: {
      title: 'Faça login e entre na sua conta',
      text: 'Digite o seu CPF/CNPJ ou E-mail',
      forgotPass: 'Gerar nova senha',
      forgotPassText:
        'Preencha com o seu e-mail ou CPF/CNPJ cadastrado e enviaremos um código de recuperação para você. O e-mail só será enviado caso o cadastro seja encontrado.',
      forgotEmailText:
        'Caso você tenha esquecido o seu e-mail, entre em contato com o atendimento <a href="/atendimento">clicando aqui</a>.',
      forgotAccountLabel: 'CPF/CNPJ/E-mail',
    },
    register: {
      submitRegisterButton: 'FINALIZAR CADASTRO',
    },
  },
  checkout: {
    register: {
      formHeaderTitle: 'PREENCHA OS SEUS DADOS PARA PROSSEGUIR COM O CADASTRO',
      preRegisterFormHeaderTitle: 'Preencha os seus dados para prosseguir com o pré-cadastro',
    },
    modalSixPeriodicity: {
      title: 'ATENÇÃO',
      message: 'Os planos com duração semestral não possuem o benefício do kit de boas-vindas. Você receberá apenas a carteirinha. Caso deseje receber o kit, altere a periodicidade para Anual.',
    },
    offState: {
      modalOffState: {
        title: 'ATENÇÃO',
        message: 'Você selecionou um plano fora do estado do RS, iremos te redirecionar para página de planos para selecionar o plano correto.',
      },
    },
    instructions: {
      bankSlip: [
        'Imprima o boleto e pague no banco.',
        'Ou pague pela internet utilizando o código de barras do boleto.',
        'O prazo de validade do boleto são 3 dias úteis.',
      ],
      pix: [
        'Acesse o app do seu banco e vá na área PIX.',
        'Aponte sua câmera para o QR Code ou copie e cole o código.',
        'Conclua o pagamento através do app.',
      ],
    },
    processingPage: {
      title: 'Agora falta pouco! Seu pagamento está sendo processado.',
      message: 'Recebemos seu pedido. Em breve você receberá um e-mail com todos os detalhes.',
      buttons: {
        seusPacotes: 'SEUS PACOTES',
        paginaDeEventos: 'PÁGINA DE EVENTOS',
      },
    },
    successPage: {
      title: 'Compra efetuada com Sucesso! Seu pagamento foi processado.',
      message: 'Seu pagamento foi realizado com sucesso! Em breve você receberá um e-mail com todos os detalhes. Bom evento!',
      buttons: {
        seusPacotes: 'SEUS PACOTES',
        paginaDeEventos: 'PÁGINA DE EVENTOS',
      },
    },
    boletoPage: {
      title: 'BOLETO GERADO COM SUCESSO!',
      message: 'Agora falta pouco! Pague o seu boleto até a data de vencimento.',
      instructions: 'O Boleto é compensado em até 3 dias após o pagamento.<br /><br />Após compensado o pagamento do <b>Título</b>, seu boleto do plano estará disponínel em <b>Minha Conta > Pagamentos</b>',
      buttons: {
        imprimirBoleto: 'IMPRIMIR BOLETO',
      },
    },
    pixPage: {
      title: 'Pague a fatura gerada através do QR Code abaixo.',
      message: 'Aponte seu telefone para a tela, ou copie o codigo PIX. O pagamento via PIX é compensado pouco tempo após o pagamento.',
      instructions: 'Após confirmar o pagamento do <b>Título</b>, seu plano estará disponínel para pagamento em <b>Minha Conta > Pagamentos</b>',
      buttons: {
        copiarCodigoPix: 'COPIAR CÓDIGO PIX',
      },
    },
    successPageSe: {
      title: 'Agora falta pouco.',
      message: 'Seu contrato será gerado dentro de instantes.',
    },
    paymentFailPage: {
      title: 'Ocorreu um erro ao efetuar o seu pagamento!',
      message: 'Não foi possível processar o seu pagamento na forma de pagamento selecionada.',
      buttons: {
        tentarNovamente: 'TENTAR NOVAMENTE',
        paginaDeEventos: 'PÁGINA DE EVENTOS',
      },
    },
  },
  account: {
    profile: {
      partnerSince: 'Sócio desde',
      personalDataTitle: 'dados pessoais',
      addressTitle: 'Meu Endereço',
      notInformed: 'Dado não informado',
      emailNotRegistered: 'E-mail não cadastrado',
      birthDateLabel: 'Data de nascimento',
      birthDateNotRegistered: 'Nascimento não cadastrado',
      phoneLabel: 'Telefone',
      cellPhoneNotRegistered: 'Celular não cadastrado',
      advisorLabel: 'Assessor',
      editPersonalData: 'ALTERAR DADOS PESSOAIS',
      cellPhoneLabel: 'Celular',
      requiredField: 'Este campo é obrigatório',
      cellPhoneMinLength: 'Este campo deve ter 9 caracteres',
      cancelUpload: 'Cancelar Upload',
      saveImage: 'Salvar Imagem',
      emailVerifiedTooltip: 'E-mail verificado',
      verifyEmailTooltip: 'Verifique sua caixa de e-mail para confirmar este endereço',
      editProfilePhoto: 'ALTERAR FOTO DE PERFIL',
      birthLabel: 'Nascimento',
    },
  },
  plans: {
    defaultSubscribeText: 'QUERO SER SÓCIO',
    customSubscribeText: 'QUERO ESTE!',
    sectionTitle: 'VANTAGENS EXCLUSIVAS PARA OS SÓCIOS ESTATUTÁRIOS',
    conditions: [
      '*Válido para jogos de futebol, basquete e futsal.',
      '**Acesso social em dias de jogos conforme regras da operação do evento, divulgadas previamente.',
      '***13º pagamento no mesmo valor e vencimento da mensalidade de Dezembro.',
      '****Gênero feminino tem 20% de desconto no pagamento da joia.',
    ],
  },
  matches: {
    nextMatchText: 'Próximo jogo',
    modalities: {
      FUTEBOL: 'FUTEBOL',
      FUTSAL: 'FUTSAL',
      BASQUETE: 'BASQUETE',
      ESPORTE: 'ESPORTE',
      OUTROS: 'OUTROS',
    },
    phases: {
      AGENDADO: 'AGENDADO',
      FASE_UNICA: 'FASE ÚNICA',
      CONFIRMADO: 'CONFIRMADO',
      ADIADO: 'ADIADO',
      CANCELADO: 'CANCELADO',
    },
    highlightBanner: {
      title: 'Garanta seu ingresso e faça história no lendário Maracanã!',
      subtitle: 'Tour Maracanã',
      buttonText: 'COMPRE AGORA',
    },
  },
  xRay: {
    about: {
      title: 'Sobre a Fla-Flu Serviços S.A.',
      description: 'Inaugurada em setembro de 2024, a Fla-Flu Serviços S.A. é a empresa responsável pela administração do Complexo Maracanã, que inclui o Maracanã e o Maracanãzinho. Formada pelos clubes Flamengo e Fluminense, a sociedade dá continuidade ao trabalho iniciado em abril de 2019, quando ambos assumiram a gestão do estádio. A constituição empresa ocorreu após a vitória do Consórcio Fla-Flu na licitação pública promovida pelo Governo do Estado do Rio de Janeiro, em setembro de 2024. A partir daí, foi criada formalmente a Fla-Flu Serviços S.A, uma Sociedade de Propósito Específico (SPE) com o objetivo de garantir a administração, operação e manutenção do estádio. Desde abril de 2019, a gestão já investiu mais de R$ 120 milhões para conforto e segurança de atletas, torcedores e prestadores de serviços. Nesse período, o Maracanã recebeu mais de 13 milhões de público e foi palco de grandes momentos do esporte como duas finais de Libertadores e duas de Copa América.',
      cards: {
        transparencia: {
          title: 'Transparência',
          buttonText: 'ACESSE',
        },
        ouvidoria: {
          title: 'Ouvidoria',
          buttonText: 'OUVIDORIA',
        },
        canalDeDenuncias: {
          title: 'Canal de denúncias',
          buttonText: 'DENUNCIE',
        },
      },
    },
  },
  embassies: {
    embassiesPage: {
      beforeTableHTML: `
        <h1>Embaixadas <strong>Fengers</strong></h1>
        <p>
          O clube que ganhou o mundo segue sua expansão global para que torcedores de qualquer lugar possam viver de perto a emoção que é torcer com experiências exclusivas e toda diplomacia que merece.
        </p>
        <p>
          A criação das Embaixadas já começou e queremos ver este mapa repleto de representatividade para os torcedores de todos os lugares do mundo. Sabemos que nossa torcida é imensa e merece viver essa paixão de perto, mesmo que morando longe.
        </p>
      `,
      afterTableHTML: `
        <p>
          Você, que é de outro país ou estado brasileiro, pode unir fãs da sua região e fundar uma Embaixada. Desta forma, você será o responsável por representar um verdadeiro embaixador, levando benefícios e mediando junto ao seu clube de coração experiências exclusivas para todos que fizerem parte de sua Embaixada.
        </p>
      `,
    },
  },
  faq: {
    contacts: {
      sac: [
        '<p>Ouvidoria: <a href="https://www.contatoseguro.com.br/pt/maracanaouvidoria">https://www.contatoseguro.com.br/pt/maracanaouvidoria</a>',
      ],
    },
    contactInfo: {
      intro: 'Caso ainda tenha alguma dúvida, entre em contato com o {projectName}',
      viaChat: ' através do nosso chat',
      viaChatAvailability: ' ({availability}).',
      viaChatEnd: '.',
      viaEmailOnly: ' através do nosso e-mail {email}.',
      viaEmailOptional: ' Caso prefira, envie um email para {email}.',
    },
  }
};
